module.exports = __webpack_public_path__ + "img/c00_buildingtechnetlandline_Normal_ua.2ef61caa.webp";